var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerMobileOfficeSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pin_mobile_office",
    "data-name": "Pin mobile office",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 48,
    viewBox: "0 0 32 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9762",
    "data-name": "Rectangle 9762",
    width: 19,
    height: 13.013,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dropshape",
    d: "M32,15.412a16.857,16.857,0,0,1-1.746,7.549L17.011,47.406a1.147,1.147,0,0,1-2.01,0L1.574,22.619A17.145,17.145,0,0,1,0,15.412C0,6.739,7.373,0,16.009,0S32,6.735,32,15.412Z",
    fill: "#4877ce"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "original_truck",
    "data-name": "original truck",
    transform: "translate(7 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23610",
    "data-name": "Group 23610",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20060",
    "data-name": "Path 20060",
    d: "M3.518,10.6A1.751,1.751,0,1,1,5.277,8.847,1.775,1.775,0,0,1,3.518,10.6",
    transform: "translate(0.605 2.417)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20061",
    "data-name": "Path 20061",
    d: "M18.31,5.2A1.742,1.742,0,0,1,19,6.613V9.55a1.644,1.644,0,0,1-1.28,1.666,2.6,2.6,0,0,0-5.188.021h-5.8A2.56,2.56,0,0,0,4.157,8.687H4.12a2.566,2.566,0,0,0-2.583,2.547v0h-.02A1.61,1.61,0,0,1,0,9.55V1.688A1.607,1.607,0,0,1,1.516,0H11.951a1.39,1.39,0,0,1,.827.275.514.514,0,0,1,.11.075ZM11.879,1.26h-1.56V5.507h6.29Z",
    transform: "translate(0 0.001)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20062",
    "data-name": "Path 20062",
    d: "M11.719,10.6a1.751,1.751,0,1,1,1.759-1.749A1.775,1.775,0,0,1,11.719,10.6",
    transform: "translate(3.398 2.417)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerMobileOfficeSelected);
export default __webpack_public_path__ + "static/media/marker-mobile-office-selected.32caba5c998c7ed66c24485eb33e5e82.svg";
export { ForwardRef as ReactComponent };